import React from "react";
import { Badge, IndexTable, Link, Page, Text } from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";
import { useTranslation } from "react-i18next";
import PlaceTable from "../../components/PlaceTable";

export default function CitiesIndex(props) {
  const { t } = useTranslation();
  
  return (
    <Page fullWidth>
      <TitleBar title={t("cities.title")} breadcrumbs={[]} />
      <PlaceTable
        headings={[
          { title: t("cities.headings.name") },
          { title: t("cities.headings.status") },
          { title: t("cities.headings.locations") },
          { title: t("cities.headings.region") },
          { title: t("cities.headings.country") },
        ]}
        isLocationList={false}
        url="/cities"
        resourceName={{ singular: t("cities.resourceSingular"), plural: t("cities.resourcePlural") }}
        renderLocation={({
          id,
          url,
          name,
          locations_count,
          country,
          region,
          published,
        }) => (
          <IndexTable.Row key={id} id={id}>
            <IndexTable.Cell>
              <div style={{ padding: "var(--p-space-2) 0px" }}>
                <Link url={url} monochrome removeUnderline>
                  <Text  variant="bodyMd" as="span" fontWeight="semibold">{name}</Text>
                </Link>
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
              {published ? (
                <Badge status="success">{t("location.index.published")}</Badge>
              ) : (
                <Badge>{t("location.index.draft")}</Badge>
              )}
            </IndexTable.Cell>
            <IndexTable.Cell>{locations_count}</IndexTable.Cell>
            <IndexTable.Cell>
              <Link monochrome removeUnderline url={region.url}>
                {region.name}
              </Link>
            </IndexTable.Cell>
            <IndexTable.Cell>
              <Link monochrome removeUnderline url={country.url}>
                {country.name}
              </Link>
            </IndexTable.Cell>
          </IndexTable.Row>
        )}
      />
    </Page>
  );
}
